export default __webpack_public_path__ + "static/media/Oopsie_HTB.a043b0c1.md";